import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../lib/api-client';

export function useParticipantTranscripts(userId?: string, programId?: string) {
  return useQuery({
    queryKey: ['academic-transcripts', userId, programId],
    queryFn: () => apiClient.academicTranscripts.list({ userId, programId }),
    enabled: !!userId || !!programId,
  });
}

export function useProgramTranscript(programId?: string, userId?: string) {
  return useQuery({
    queryKey: ['program-transcript', programId, userId],
    queryFn: () => apiClient.academicTranscripts.getProgramTranscript(programId!, { userId }),
    enabled: !!programId && !!userId,
  });
}

export function useStudentProgressReport(programId?: string, userId?: string) {
  return useQuery({
    queryKey: ['student-progress-report', programId, userId],
    queryFn: () => apiClient.academicTranscripts.getProgressReport(programId!, { userId }),
    enabled: !!programId && !!userId,
  });
}

export function useLegacyTranscripts(userId?: string) {
  return useQuery({
    queryKey: ['legacy-academic-transcripts', userId],
    queryFn: () => apiClient.academicTranscripts.getLegacy({ userId }),
    enabled: !!userId,
  });
}
